// 孵化服务
import {
	getTutorList,
	getTutorDetail,
	getParkService,
	getParkServiceDetailById,
} from '@/api'

export default {
	namespaced: true,
	state: {
		tutorList: {},
		tutorDetail: {},
		parkServiceContent: '',
		parkServiceList: {},
		parkServiceDetail: {
			content: '',
			create_time: '',
			parkscode: '',
			picture: '',
			platformCode: '',
			profile: '',
			sort: 1,
			status: 0,
			title: '',
		},
	},
	mutations: {
		setTutorList(state, payload) {
			if (payload.page && payload.page.list.length > 0) {
				state.tutorList = payload.page
			}
		},
		setTutorDetail(state, payload) {
			// if (payload.code === '0') {
			state.tutorDetail = payload.data
			//}
		},
		tutorDetailClear(state) {
			state.tutorDetail = {}
		},
		setParkServiceContent(state, payload) {
			state.parkServiceContent = payload
		},
		setParkServiceList(state, payload) {
			state.parkServiceList = payload
		},
		setParkServiceDetail(state, payload) {
			state.parkServiceDetail = payload
		},
	},
	actions: {
		fetchTutorList({ commit }, payload) {
			getTutorList(payload.page).then((result) => {
				commit('setTutorList', result)
			})
		},
		fetchTutorDetail({ commit }, payload) {
			getTutorDetail(payload.id).then((result) => {
				commit('setTutorDetail', result)
			})
		},
		fetchParkService({ commit }, payload) {
			const parkType = payload.parkType || 1
			getParkService(parkType).then((res) => {
				if (res.data) {
					commit('setParkServiceContent', res.data.content)
				} else {
					commit('setParkServiceList', res.page.list)
				}
			})
		},
		fetchParkServiceDetail({ commit }, payload) {
			getParkServiceDetailById(payload.id).then((res) => {
				commit('setParkServiceDetail', res.data)
			})
		},
	},
}
